import { useState } from "react";
import type { FormEvent } from "react";
import { footerColumns, heroTags } from "@/mocks/home-data";

export default function SubscribeFooter() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // 静态展示：不接入真实提交，仅模拟成功反馈
    setDone(true);
  };

  return (
    <>
      {/* 订阅带 */}
      <section id="dingyue" className="border-t border-background-200 bg-foreground-950 py-14 md:py-20">
        <div className="mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-8 px-4 md:px-6 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/20 px-3 py-1.5 font-label text-xs font-semibold text-accent-300">
              <i className="ri-mail-send-line" /> 每日瓜报 · 早八送达
            </span>
            <h2 className="display-serif mt-4 text-2xl font-black leading-snug text-background-50 md:text-4xl">
              错过一个瓜，就错过一次全场热闹。
              <br />
              订阅后，明天的新雷不会漏。
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-300">
              每天早上一封瓜报：雷点整理、吃瓜清单、事件脉络一页打包，点开即吃，跟群不落队。
            </p>
          </div>

          <div className="rounded-lg border border-background-200/30 bg-background-50 p-5 md:p-6">
            {done ? (
              <div className="flex flex-col items-center gap-3 py-8 text-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-check-double-line text-2xl" />
                </span>
                <p className="display-serif text-lg font-bold text-foreground-950">订阅成功，明早见！</p>
                <p className="text-sm text-foreground-600">
                  已为你登记，每日瓜报会在早八准时送达（本页为静态展示，不实际发送）。
                </p>
              </div>
            ) : (
              <form onSubmit={onSubmit} noValidate>
                <label htmlFor="subscribe-email" className="font-label text-sm font-semibold text-foreground-800">
                  用邮箱领取你的每日瓜报
                </label>
                <div className="mt-3 flex flex-col gap-2 sm:flex-row">
                  <input
                    id="subscribe-email"
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    className="h-11 flex-1 rounded-md border border-background-300 bg-background-50 px-3.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
                  />
                  <button
                    type="submit"
                    className="h-11 whitespace-nowrap rounded-md bg-primary-500 px-5 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    立即订阅
                  </button>
                </div>
                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="sp-field"
                />
                <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-lock-line" /> 你的邮箱只用于接收瓜报，不会出现在任何站队里。
                </p>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* 页脚 */}
      <footer className="border-t border-background-200 bg-background-200/70">
        <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
            <div className="md:col-span-5">
              <a href="#top" className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-flashlight-fill text-lg" />
                </span>
                <span className="font-heading text-lg font-black text-foreground-950">
                  大雷<span className="text-primary-600">网站</span>
                </span>
              </a>
              <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
                大雷网站大瓜合集专注雷点整理与劲爆盘点，把吃瓜清单和事件脉络摊清楚，让你快速掌握每个大瓜的来龙去脉。
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {heroTags.slice(0, 4).map((t) => (
                  <span
                    key={t}
                    className="rounded-full border border-background-300 bg-background-50 px-3 py-1 font-label text-xs text-secondary-700"
                  >
                    #{t}
                  </span>
                ))}
              </div>
            </div>

            {footerColumns.map((col) => (
              <nav key={col.title} className="md:col-span-2" aria-label={col.title}>
                <h4 className="font-label text-sm font-semibold text-foreground-950">{col.title}</h4>
                <ul className="mt-3 flex flex-col gap-2.5">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <a href={l.href} className="font-label text-sm text-foreground-600 transition-colors hover:text-primary-600">
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}

            <div className="md:col-span-1" />
          </div>

          <div className="mt-10 flex flex-col gap-3 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-label text-xs text-foreground-500">
              © 2026 大雷网站 · 页面内容仅供娱乐与吃瓜交流，不构成事实判断
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="font-label text-xs text-foreground-500 hover:text-primary-600" rel="nofollow">投稿</a>
              <a href="#" className="font-label text-xs text-foreground-500 hover:text-primary-600" rel="nofollow">合作</a>
              <a href="#" className="font-label text-xs text-foreground-500 hover:text-primary-600" rel="nofollow">站务说明</a>
              <a href="#" className="font-label text-xs text-foreground-500 hover:text-primary-600" rel="nofollow">意见反馈</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}